import {
  LinearEncoding,
  GammaEncoding,
  sRGBEncoding,
  LinearEncoding,
  sRGBEncoding,
  GammaEncoding,
  RGBEEncoding,
  LogLuvEncoding,
  RGBM7Encoding,
  RGBM16Encoding,
  RGBDEncoding,
  BasicDepthPacking,
  RGBADepthPacking,
  WebGLRenderer,
} from 'three'
import settings from './settings';
import { component } from '../bidello'

class Renderer extends component(WebGLRenderer) {
  constructor() {
    super({
      antialias: false,
      powerPreference: 'low-power',
      // antialias: true,
      trasparent: true
    })

    // this.gammaFactor = 2.2
    // this.gammaInput = true
    // this.gammaOutput = true

    this.outputEncoding = sRGBEncoding
    // this.outputEncoding = LinearEncoding
    // this.outputEncoding = GammaEncoding

    // this.setClearColor(0x011c22)\
    this.setPixelRatio(settings.dpr)
  }

  onResize({ width, height }) {
    this.setSize(width, height)
  }
}

export default new Renderer()
